import { useState } from 'react';
import { SeoLinks } from '../../../dummyData/homePage';
import './seo.css';
import { useNavigate } from 'react-router-dom';

const SeoSection = () => {
    const [limit] = useState(9);
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(`/search-result/trip/${path}`, {
            state: { limit }
        });
    };
    return (
        <div className='seoBg mobHidden'>
            <div className='customContainer justifyCenter'>
                {SeoLinks.map((item, index) => {
                    return (
                        <button onClick={() => handleNavigate(item)} key={index} className='seoBtn'>
                            {item}
                            <span />
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SeoSection;
